import React, { Component } from "react"
import { connect } from 'react-redux'
import { IMG } from "../../themes"

import { TOAST } from "./style"
import { NOTIFICATION } from '../../reduxs'
import { backgroundToast, iconToast } from "../../helpers"
class Toast extends Component {
  render() {
    const {
      onClick,
      onClickCloseToast,
      textButton,
      isOpenToastNotification,
      notificationPayload,
    } = this.props
    
    return (
      <React.Fragment>
        {(isOpenToastNotification && notificationPayload) && (
          <TOAST style={{ background: backgroundToast(notificationPayload.data.notificationType) }}>
            <img className='icon' src={IMG[iconToast(notificationPayload.data.notificationType)]} alt='icon' />
            <span className='message'>{notificationPayload.notification.body}</span>
            <span className='action-text' onClick={onClick}>
              {textButton}
            </span>
            <div className='divider' />
            <img
              className='close-btn'
              src={IMG["close-white.svg"]}
              alt='close-btn'
              onClick={onClickCloseToast}
            />
          </TOAST>
        )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ notificationReducer }) => {
  return {
    notificationPayload: notificationReducer.payload,
    isOpenToastNotification: notificationReducer.isOpenToastNotification,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    openNotification: () => dispatch(NOTIFICATION.action.toggleNotification(true)),
    closeNotification: () => dispatch(NOTIFICATION.action.toggleNotification(false)),
    clearNotificationData: () => dispatch(NOTIFICATION.action.setNotificationData({ payload: null }))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Toast)
